var map = {
	"./Polygon@2x.png": 92,
	"./banner.png": 305,
	"./bosch.jpg": 306,
	"./closeIcon.png": 133,
	"./closeX.png": 160,
	"./gallery-1.png": 307,
	"./healthy.png": 308,
	"./insert-picture@2x.png": 91,
	"./left-arrow.png": 163,
	"./like-green.png": 134,
	"./like@2x.png": 74,
	"./natural.png": 309,
	"./plus.png": 161,
	"./right-arrow.png": 64,
	"./share.png": 162,
	"./smart.png": 310,
	"./tampines.png": 311,
	"./thankyou.png": 312,
	"./upload-icon.png": 159,
	"./voucher1@2x.png": 313
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 304;